import React, { Fragment, useState } from 'react';
import { css } from 'twin.macro';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { BsX } from 'react-icons/bs';
import { VscLoading } from 'react-icons/vsc';
import { rejectExpense } from '@/_services/api/expense';

const ModalCSS = css`
    .modal-header {
        color: white;
        background: #dc3545;
        button {
            color: white;
        }
    }
    .modal-body {
        padding: 1.5rem;
    }
    .form-label {
        font-weight: 600;
        color: #333;
        margin-bottom: 0.5rem;
    }
    .expense-info {
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 8px;
        padding: 1rem;
        margin-bottom: 1rem;
    }
    .expense-amount {
        font-size: 1.2rem;
        font-weight: bold;
        color: #50aeb0;
    }
`;

const ExpenseRejectModal = ({ expense, handleUpdateExpense }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [rejectReason, setRejectReason] = useState('');
    const [isBusy, setIsBusy] = useState(false);
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const handleRejectExpense = async () => {
        try {
            setIsBusy(true);
            const reason = (rejectReason || '').trim();
            const expenseId = expense?._id;
            if (!reason) {
                return toast.error('Please provide a reason for rejection');
            }
            const response = await rejectExpense({
                expenseId,
                reason,
            });
            handleUpdateExpense(response);
            toast.success('Expense rejected successfully');
            setRejectReason('');
            handleClose();
        } catch (error) {
            toast.error(error.message || 'Failed to reject expense');
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <Fragment>
            <BootstrapToolTip text="Reject">
                <BsX className="icon delete" onClick={handleOpen} />
            </BootstrapToolTip>
            <Modal show={isOpen} onHide={handleClose} css={ModalCSS}>
                <Modal.Header closeButton>
                    <Modal.Title>Reject Expense</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="form-label">
                            Reason for Rejection <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value || '')}
                            placeholder="Please provide a detailed reason for rejecting this expense..."
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            handleRejectExpense();
                        }}
                        disabled={!rejectReason.trim() || isBusy}
                    >
                        {isBusy ? <VscLoading className="spin" /> : 'Reject Expense'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default ExpenseRejectModal;
